






















	import Vue from 'vue';
    import _moderation from '../../services/endpoints/moderation';
	import { UserRole } from '../../../../models/Enums';

    export default Vue.extend({
        name: "ModRaidErstellenComp",
        data: () => ({
            enteredName: '',
            open: false
        }),
		computed: {
			disabled: function(): boolean {
				return this.$vStore.getters.loggedInUser.role <= UserRole.Maz;
			}
		},
        methods: {
            submit: async function(): Promise<void> {
                if (this.enteredName) {
                    await _moderation.createRaid(this.enteredName);
                    this.open = false;
                    this.enteredName = '';
                    this.$emit('refresh');
                }
            }
        }
    })
